import { Box, Card, Grid } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import GradientBorder from "examples/GradientBorder";
import VuiButton from "components/VuiButton";
import VuiInput from "components/VuiInput";
import React from "react";
import { getAssociateInfo } from "services/customers/customers.services";

export default function AssociateReportsInfo() {
  const [data, setData] = React.useState({
    customerId: 0,
    partnersCount: [
      {
        name: "",
        count: 0,
      },
    ],
    commission: 0,
    totalCommissions: 0,
  });

  React.useEffect(() => {
    const fetchData = async () => {
      const { success, data } = await getAssociateInfo();
      if (success) {
        if (data.partnersCount.length > 0) {
          setData(data);
        }
      }
    };
    fetchData();
  }, []);

  return (
    <Grid item spacing={2} container padding={"13px"}>
      <Grid container spacing={2}>
        <Grid item>
          <Card
            sx={{
              color: "#fff",
            }}
          >
            {data.partnersCount.map((item) => (
              <VuiBox key={item.name}>
                <VuiTypography
                  sx={{
                    fontSize: "16px",
                    fontWeight: "700",
                    lineHeight: "32px",
                    color: "#FFFFFF",
                  }}
                >
                  Cantidad de referidos {item.name}: {item.count}
                </VuiTypography>
              </VuiBox>
            ))}
          </Card>
        </Grid>

        <Grid item>
          <Card
            sx={({ breakpoints }) => ({
              color: "#fff",
            })}
          >
            <VuiBox>
              <VuiTypography
                sx={{
                  fontSize: "16px",
                  fontWeight: "700",
                  lineHeight: "32px",
                  color: "#FFFFFF",
                }}
              >
                Comisión (%): {data.commission}
              </VuiTypography>
            </VuiBox>

            <VuiBox>
              <VuiTypography
                sx={{
                  fontSize: "16px",
                  fontWeight: "700",
                  lineHeight: "32px",
                  color: "#FFFFFF",
                }}
              >
                Total de comisiones:
                {data.totalCommissions.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
              </VuiTypography>
            </VuiBox>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
}
